<template>
  <div
    class="z-[50] bg-white w-[80%] shadow-[0_4px_12px_rgba(0,0,0,0.1),0_-4px_12px_rgba(0,0,0,0.05)] sm:mx-auto sm:w-full sm:max-w-lg dark:bg-slate-800 dark:shadow-[0_4px_12px_rgba(255,255,255,0.2),0_-4px_12px_rgba(255,255,255,0.1)] p-11 sm:rounded-lg"
    style="border-radius: 12px;"
  >
    <slot name="content" />
  </div>
</template>
